import { INVALID_URL, INVALID_URL_NOT_HTTPS } from "@/constants/invalids";
import { PATTERN } from "@/constants/pattern";
import { validator } from "@/utils/validator";

const SINGLE_CHAR_MESSAGE = "半角アルファベット1文字で入力してください。";

export const masterDataProductSchema = validator.object().shape({
  name: validator.string().emptyToNull().max(100).label("プロダクト名").required(),
  logo: validator.string().emptyToNull().label("ロゴ").required(),
  introductionPageUrl: validator
    .string()
    .emptyToNull()
    .max(512)
    .customURL()
    .test("notHttp", INVALID_URL_NOT_HTTPS, (value) => !value || !/^http:\/\//i.test(value))
    .label("紹介ページURL")
    .nullable()
    .notRequired(),
  apiEndpoint: validator.string().emptyToNull().max(512).matches(PATTERN.API_ENDPOINT, INVALID_URL).label("APIエンドポイントURL").required(),
  singleCharLabel: validator
    .string()
    .emptyToNull()
    .max(1)
    .matches(/^[A-Za-z]$/, SINGLE_CHAR_MESSAGE)
    .label("1文字表記")
    .required(),
  publishedAt: validator.mixed().isDayjs().label("公開日時").nullable().optional(),
});
